// Format helpers for the Sales Drill-Down dashboard.

export const fmtINR = (n) => {
  const v = Math.round(Number(n) || 0);
  return "₹" + v.toLocaleString("en-IN");
};

export const fmtINR2 = (n) => {
  const v = Number(n) || 0;
  return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Compact INR — ₹1.2L / ₹2.4Cr — for KPI tiles when value is large.
export const fmtINRCompact = (n) => {
  const v = Math.round(Number(n) || 0);
  if (v >= 10000000) return "₹" + (v / 10000000).toFixed(2) + " Cr";
  if (v >= 100000) return "₹" + (v / 100000).toFixed(2) + " L";
  if (v >= 1000) return "₹" + (v / 1000).toFixed(1) + " K";
  return "₹" + v.toLocaleString("en-IN");
};

// Render server-supplied date strings (ISO or date-only) consistently.
export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = typeof d === "string" ? new Date(d) : d;
  if (!(dt instanceof Date) || isNaN(dt.getTime())) return String(d);
  return dt.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Convert a Date (or anything new Date() understands) to the YYYY-MM-DD
// shape every controller endpoint expects.
export const toApiDate = (d) => {
  const dt = typeof d === "string" ? new Date(d) : d;
  if (!(dt instanceof Date) || isNaN(dt.getTime())) return "";
  return (
    dt.getFullYear() +
    "-" +
    String(dt.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(dt.getDate()).padStart(2, "0")
  );
};

// Date presets for the filter bar — keys are stable for active-state.
export const DATE_PRESETS = [
  {
    key: "today",
    label: "Today",
    range: () => {
      const t = new Date();
      return { from: toApiDate(t), to: toApiDate(t) };
    },
  },
  {
    key: "yesterday",
    label: "Yesterday",
    range: () => {
      const t = new Date();
      t.setDate(t.getDate() - 1);
      return { from: toApiDate(t), to: toApiDate(t) };
    },
  },
  {
    key: "last7",
    label: "Last 7 days",
    range: () => {
      const today = new Date();
      const from = new Date();
      from.setDate(today.getDate() - 6);
      return { from: toApiDate(from), to: toApiDate(today) };
    },
  },
  {
    key: "last30",
    label: "Last 30 days",
    range: () => {
      const today = new Date();
      const from = new Date();
      from.setDate(today.getDate() - 29);
      return { from: toApiDate(from), to: toApiDate(today) };
    },
  },
  {
    key: "thisMonth",
    label: "This month",
    range: () => {
      const today = new Date();
      const from = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: toApiDate(from), to: toApiDate(today) };
    },
  },
  {
    key: "lastMonth",
    label: "Last month",
    range: () => {
      const t = new Date();
      const from = new Date(t.getFullYear(), t.getMonth() - 1, 1);
      const to = new Date(t.getFullYear(), t.getMonth(), 0);
      return { from: toApiDate(from), to: toApiDate(to) };
    },
  },
  {
    key: "ytd",
    label: "Year to date",
    range: () => {
      const today = new Date();
      const from = new Date(today.getFullYear(), 0, 1);
      return { from: toApiDate(from), to: toApiDate(today) };
    },
  },
];

// Default date range — last 30 days.
export const defaultRange = () => DATE_PRESETS.find((p) => p.key === "last30").range();
